import './SimpleLoader.css'; // Assuming you put the CSS in Loader.css

import React from 'react';

const SimpleLoader = () => {
  return (
      <div className="loader"></div>
  );
};

export default SimpleLoader;
